import { TranslationService } from '@/backend/market'
import { TranslationRepository } from '../../domain/repositories/TranslationRepository'
import { TranslationModel } from '../models/TranslationModel'
import type { TranslationEntity } from '../../domain/entities/TranslationEntity'
import { UpdateTranslationEntity } from '../../domain/entities/UpdateTranslationEntity'

export class TranslationRepositoryImpl implements TranslationRepository {
  async getTranslations(): Promise<TranslationEntity[] | { error: true }> {
    try {
      const response = await TranslationService.getTranslationsAdmin()
      const translationModels = response.textTranslations?.map(
        (translation) => new TranslationModel(translation)
      )
      return translationModels ?? []
    } catch {
      return { error: true }
    }
  }
  async updateTranslation(
    id: number,
    translationData: UpdateTranslationEntity[]
  ): Promise<{ success: true } | { error: true }> {
    try {
      await TranslationService.putTranslationAdmin({
        id,
        requestBody: {
          values: translationData
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
